import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/CarRowOverview.css";

function formatNumberWithCommas(number) {
  if (number === null || number === undefined) return "";
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function CarRowOverview({ carro }) {
  const navigate = useNavigate();

  const rawImage = carro?.imagenes?.[0] || "";
  const imageUrl = rawImage.replace("http://", "https://");

  const goToDetail = () => {
    navigate("/info/" + carro._id);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      goToDetail();
    }
  };

  const specs = [
    carro?.anio,
    carro?.millaje != null ? `${formatNumberWithCommas(carro.millaje)} millas` : null,
    carro?.combustible,
    carro?.transmission,
    carro?.ubicacion,
  ].filter(Boolean);

  const isOnSale = Boolean(carro?.offerta) && Number(carro?.precioOferta) > 0;

  return (
    <div
      className="stock-row-card"
      onClick={goToDetail}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="stock-row-media">
        {imageUrl ? (
          <img src={imageUrl} alt={`${carro?.marca || ""} ${carro?.modelo || ""}`} loading="lazy" />
        ) : (
          <div className="stock-row-media-placeholder">Sin imagen</div>
        )}
        {carro?.thirdPartySeller && (
          <span className="stock-row-badge">Vendedor Externo</span>
        )}
        {isOnSale && (
          <span className="stock-row-offer-badge">Oferta</span>
        )}
        {carro?.enSubasta && (
          <span className="stock-row-auction-badge">En subasta</span>
        )}
      </div>

      <div className="stock-row-body">
        <div className="stock-row-head">
          {carro?.lote && carro.lote !== "0" && (
            <span className="stock-row-lote">Lote: {carro.lote}</span>
          )}
          <h3 className="stock-row-title">
            {carro?.marca} {carro?.modelo} {carro?.anio}
          </h3>
        </div>

        {specs.length > 0 && (
          <div className="stock-row-specs">
            {specs.map((spec, i) => (
              <span key={i} className="stock-row-chip">
                {spec}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="stock-row-price-col">
        <span className="stock-row-price-label">
          {isOnSale ? "Precio oferta" : "Precio"}
        </span>
        {isOnSale && (
          <span className="stock-row-price-original" translate="no">
            L.{formatNumberWithCommas(carro?.precio || 0)}
          </span>
        )}
        <span className="stock-row-price" translate="no">
          L.{formatNumberWithCommas(
            isOnSale ? carro.precioOferta : carro?.precio || 0
          )}
        </span>
        <span className="stock-row-cta">Ver detalles →</span>
      </div>
    </div>
  );
}

export default CarRowOverview;
